import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userModuleApi } from "../../utils/api/services";
import {
  resetRehydration,
  setRehydration,
  setUserCompanyInfo,
  setUserModules,
} from "../../utils/store/auth/AuthSlice";
import { RootState } from "../../utils/store";
import { useLocation } from "react-router-dom";

export const useRehydrateModules = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token, LoginData, userModules, isRehydrated } = useSelector(
    (state: RootState) => state.auth
  );
  useEffect(() => {
    const shouldFetchModules =
      token &&
      LoginData?.id &&
      location.pathname !== "/sso-login" &&
      (!isRehydrated || userModules.length === 0);

    const fetchModules = async () => {
      if (!shouldFetchModules) return;
      dispatch(resetRehydration());
      if (token && LoginData?.id && userModules?.length === 0) {
        try {
          const res = await userModuleApi(LoginData?.id);
          if (res?.success) {
            dispatch(setUserModules(res?.data?.userModuleinfo));
            dispatch(setUserCompanyInfo(res?.data?.userCompanyInfo));
            dispatch(setRehydration());
          }
        } catch (err) {
          dispatch(setRehydration());
          console.error("Error fetching modules after refresh", err);
        }
      }
    };
    fetchModules();
  }, [token, LoginData, userModules?.length, dispatch]);
};
